var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('form-field-date');
export var FormFieldDateDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])))
};
export var FormFieldDate = function (props) {
  var className = props.className,
    value = props.value;
  return React.createElement(My.Container, {
    className: cls.name(className)
  });
};
FormFieldDate.cls = cls;
FormFieldDate.defaultProps = FormFieldDateDefaultProps;
var templateObject_1, templateObject_2;